import ResumeCard from '@/src/app/components/cards/ResumeCard';
import ErrorMessage from '@/src/app/components/messages/ErrorMessage';
import { DashboardClaimPolicySummary } from '@/src/app/Interfaces/Insurance/Claim';
import { useState } from 'react';
import { Link } from 'react-router-dom';
import ClaimTableDrilldown from './ClaimTableDrilldown';
import Table from '@/src/app/components/Table/Table';
import { Column } from 'primereact/column';
import { formatDate } from '@/src/utils/formatUtils';
import WrapperButton from '@/src/app/components/buttons/WrapperButton';

export type ClaimSummaryProps = {
  isError: boolean;
  policies: DashboardClaimPolicySummary[];
};

const ClaimSummary = ({ isError, policies }: ClaimSummaryProps) => {
  const [showDrilldown, setShowDrilldown] = useState(false);
  const [policy, setSelectedPolicy] = useState<DashboardClaimPolicySummary>();

  const onCellClick = (policy: DashboardClaimPolicySummary) => {
    setSelectedPolicy(policy);
    setShowDrilldown(true);
  };

  const hideSelectedDrilldown = () => {
    setSelectedPolicy(undefined);
    setShowDrilldown(false);
  };

  if (isError) {
    return (
      <ResumeCard>
        <div className="relative p-5 px-4 flex flex-column h-full">
          <Link to={`/insurance/claims`} className="w-fit">
            <div className="text-24px font-bold cursor-pointer totalColor hover:underline w-fit">
              Active Claims
            </div>
          </Link>
          <div className="my-8 py-3">
            <ErrorMessage
              content={'Failed to obtain data! Please try again later.'}
            />
          </div>
        </div>
      </ResumeCard>
    );
  }

  return (
    <ResumeCard>
      <div className="p-3 px-4 flex flex-column">
        <Link to={`/insurance/claims`} className="w-fit">
          <div className="text-24px font-bold cursor-pointer totalColor hover:underline">
            Active Claims
          </div>
        </Link>
        <div className="pt-3 text-xl flex flex-wrap">
          {policy && (
            <ClaimTableDrilldown
              visible={showDrilldown}
              hideDrilldown={hideSelectedDrilldown}
              policy={{
                id: policy.id,
                policy: policy.policy,
                termStart: policy.termStart,
                termEnd: policy.termEnd,
              }}
              fetchActive={true}
              title={'Active Claims in Policy'}
            />
          )}
          <Table
            data={policies}
            className={`dashboardOptionShadow noFooter w-full`}
            fixedDefaultHeight={187}
          >
            <Column
              field="policy"
              header="Policy"
              body={(policy) => (
                <div className="scroll-text">{policy.policy}</div>
              )}
              headerClassName={`tableHeader font-normal justify-content-center`}
              style={{ minWidth: '200px', maxWidth: '200px' }}
              className={`text-standard blackText tableCell overflow-x-hidden white-space-nowrap checkOverflow`}
              footerClassName="tableFooter"
            />

            <Column
              field="termStart"
              header="Effective Date"
              style={{ minWidth: '140px' }}
              body={(policy) => {
                return formatDate(policy.termStart);
              }}
              headerClassName="tableHeader font-normal"
              className="justify-content-center text-standard blackText tableCell"
              footerClassName="tableFooter"
            />
            <Column
              field="termEnd"
              header="Expiration Date"
              style={{ minWidth: '140px' }}
              body={(policy) => {
                return formatDate(policy.termEnd);
              }}
              headerClassName="tableHeader font-normal"
              className="justify-content-center text-standard blackText tableCell"
              footerClassName="tableFooter"
            />
            <Column
              field="claims"
              header="Claims"
              body={(policy) =>
                policy.claims ? (
                  <WrapperButton
                    className="totalColor hover:underline"
                    onClick={() => onCellClick(policy)}
                  >
                    {policy.claims}
                  </WrapperButton>
                ) : (
                  policy.claims
                )
              }
              style={{ minWidth: '100px' }}
              headerClassName="tableHeader font-normal"
              className="justify-content-center text-standard blackText tableCell"
              footerClassName="tableFooter"
            />
          </Table>
        </div>
      </div>
    </ResumeCard>
  );
};

export default ClaimSummary;
